/* SEARCH */
document.getElementById("search-trigger").onclick = function() {
    document.getElementById("search").classList.add("open");
};
document.getElementById("search-close").onclick = function() {
    document.getElementById("search").classList.remove("open");
};

/* SWIPERS */
var swiperHero = new Swiper(".swiper.is-hero", {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 750,
  autoplay: {
    delay: 3000,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});
var swiperFeatured = new Swiper(".swiper.is-featured", {
  slidesPerView: 'auto',
  spaceBetween: 10,
  loop: 'true',
  speed: 750,
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
});
var swiperPDP = new Swiper(".swiper.is-pdp", {
  slidesPerView: 'auto',
  spaceBetween: 10,
  loop: 'true',
  speed: 750,
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
});
var swiperDistributors = new Swiper(".swiper.is-distributors", {
  slidesPerView: 'auto',
  centeredSlides: 'true',
  spaceBetween: 10,
  loop: 'true',
  speed: 750,
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
});

/* ANNOUNCEMENT BAR */
const closeBtn = document.getElementById("announcement-close");
const bar = document.getElementById("announcement-bar");
if (closeBtn && bar) {
  closeBtn.addEventListener("click", () => {
    bar.style.display = "none";
  });
}

/* MARQUEE 
  const init = () => {
  const marquee = document.querySelector('[wb-data="marquee"]');
  if (!marquee) {
    return;
  }
  const duration = parseInt(marquee.getAttribute("duration"), 10) || 5;
  const marqueeContent = marquee.firstElementChild;
  if (!marqueeContent) {
    return;
  }
  const marqueeContentClone = marqueeContent.cloneNode(true);
  marquee.append(marqueeContentClone);
  let tween;
  const playMarquee = () => {
    let progress = tween ? tween.progress() : 0;
    tween && tween.progress(0).kill();
    const width = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("width"),
      10
    );
    const gap = parseInt(
      getComputedStyle(marqueeContent).getPropertyValue("column-gap"),
      10
    );
    const distanceToTranslate = -1 * (gap + width);
    tween = gsap.fromTo(
      marquee.children,
      { x: 0 },
      { x: distanceToTranslate, duration, ease: "none", repeat: -1 }
    );
    tween.progress(progress);
    console.log({ width });
  };
  playMarquee();
  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(
        () => {
          func();
        },
        500,
        event
      );
    };
  }
  window.addEventListener("resize", debounce(playMarquee));
  // console.log({ marquee, marqueeContent });
};
document.addEventListener("DOMContentLoaded", init); */


/* MARQUEE */
const initMarquees = () => {
  const marquees = document.querySelectorAll('[wb-data="marquee"]');

  if (!marquees.length) return;

  marquees.forEach((marquee) => {
    const duration =
      parseInt(marquee.getAttribute("duration"), 10) || 5;

    const marqueeContent = marquee.firstElementChild;

    if (!marqueeContent) return;

    // Prevent duplicate clones if init runs again
    if (!marquee.hasAttribute("data-marquee-initialized")) {
      const marqueeContentClone = marqueeContent.cloneNode(true);
      marquee.appendChild(marqueeContentClone);
      marquee.setAttribute("data-marquee-initialized", "true");
    }

    let tween;

    const playMarquee = () => {
      const progress = tween ? tween.progress() : 0;

      if (tween) {
        tween.progress(0).kill();
      }

      const width = marqueeContent.offsetWidth;

      const gap =
        parseInt(
          getComputedStyle(marqueeContent).getPropertyValue(
            "column-gap"
          ),
          10
        ) || 0;

      const distanceToTranslate = -(width + gap);

      tween = gsap.fromTo(
        marquee.children,
        { x: 0 },
        {
          x: distanceToTranslate,
          duration,
          ease: "none",
          repeat: -1,
        }
      );

      tween.progress(progress);
    };

    playMarquee();

    const debounce = (func, delay = 500) => {
      let timer;

      return () => {
        clearTimeout(timer);

        timer = setTimeout(() => {
          func();
        }, delay);
      };
    };

    window.addEventListener("resize", debounce(playMarquee));
  });
};

document.addEventListener("DOMContentLoaded", initMarquees);

/* FANCYBOX */
$.fancybox.defaults.animationEffect = "fade";

/* POPUP */
function openPopup() {
  $(".popup-form-wrapper").addClass("open");
}
function closePopup() {
  $(".popup-form-wrapper").removeClass("open");
}

/* FEATURED PRODUCT IMAGE */
document.addEventListener('DOMContentLoaded', () => {

  const gallery = document.getElementById('pdpGallery');

  if (!gallery) return;

  const updateActiveVariantImage = () => {

    // Find currently selected variant ID input
    const variantInput = document.querySelector(
      'input[name="id"], select[name="id"]'
    );

    if (!variantInput) return;

    const variantId = variantInput.value;

    // Get variant JSON from product page
    const productData = JSON.parse(
      document.getElementById('ProductJson').textContent
    );

    // Find matching variant
    const currentVariant = productData.variants.find(
      variant => variant.id.toString() === variantId.toString()
    );

    if (!currentVariant || !currentVariant.featured_media) return;

    // Remove active class from all images
    gallery.querySelectorAll('.pdp-image-link').forEach((image) => {
      image.classList.remove('is-active-variant');
    });

    // Add active class to matching media image
    const activeImage = gallery.querySelector(
      `[data-media-id="${currentVariant.featured_media.id}"]`
    );

    if (activeImage) {
      activeImage.classList.add('is-active-variant');
    }

  };

  // Initial load
  updateActiveVariantImage();

  // Watch for variant changes
  document.addEventListener('change', (event) => {

    if (
      event.target.matches('input[name="id"]') ||
      event.target.matches('select[name="id"]')
    ) {
      updateActiveVariantImage();
    }

  });

});

/* FAQs */
var acc = document.getElementsByClassName("faqs-item");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    if (this.classList.contains('open')) {
      this.classList.toggle('open');
    } else {
      $('.faqs-item').removeClass('open');
      this.classList.toggle('open');
    }
  });
}






class ccPopup {
    constructor($container, namespace) {
      this.$container = $container;
      this.namespace = namespace;
      this.cssClasses = {
        visible: 'cc-popup--visible',
        bodyNoScroll: 'cc-popup-no-scroll',
        bodyNoScrollPadRight: 'cc-popup-no-scroll-pad-right'
      };
    }

    /**
     * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close
     * Add the cc-popup--visible class
     * Update aria to visible
     */
    open(callback) {
      // Prevent the body from scrolling
      if (this.$container.data('freeze-scroll')) {
        clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId);
        $('body').addClass(this.cssClasses.bodyNoScroll);

        // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'popup-scrollbar-measure';
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        if (scrollbarWidth > 0) {
          $('body').css('padding-right', scrollbarWidth + 'px').addClass(this.cssClasses.bodyNoScrollPadRight);
        }
      }

      // Add reveal class
      this.$container.addClass(this.cssClasses.visible);

      // Track previously focused element
      this.previouslyActiveElement = document.activeElement;

      // Focus on the close button after the animation in has completed
      setTimeout(() => {
        this.$container.find('.cc-popup-close')[0].focus();
      }, 500);

      // Pressing escape closes the modal
      $(window).on('keydown' + this.namespace, (event) => {
        if (event.keyCode === 27) {
          this.close();
        }
      });

      if (callback) {
        callback();
      }
    }

    /**
     * Close popup on click of close button or background - where does the focus go back to?
     * Remove the cc-popup--visible class
     */
    close(callback) {
      // Remove reveal class
      this.$container.removeClass(this.cssClasses.visible);

      // Revert focus
      if (this.previouslyActiveElement) {
        $(this.previouslyActiveElement).focus();
      }

      // Destroy the escape event listener
      $(window).off('keydown' + this.namespace);

      // Allow the body to scroll and remove any scrollbar-compensating padding, if no other scroll-freeze popups are visible
      var $visibleFreezePopups = $('.' + this.cssClasses.visible).filter(() => {return this.$container.data('freeze-scroll');});
      if ($visibleFreezePopups.length === 0) {
        var transitionDuration = 500;

        var $innerModal = this.$container.find('.cc-popup-modal');
        if ($innerModal.length) {
          transitionDuration = parseFloat(getComputedStyle($innerModal[0])['transitionDuration']);
          if (transitionDuration && transitionDuration > 0) {
            transitionDuration *= 1000;
          }
        }

        theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout(() => {
          $('body').removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css('padding-right', '0');
        }, transitionDuration);
      }

      if (callback) {
        callback();
      }
    }
  };

  theme.Popup = new function () {
    /**
     * Popup section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    var dismissedStorageKey = 'cc-theme-popup-dismissed';

    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.popup = new ccPopup(this.$container, this.namespace);

      var dismissForDays = this.$container.data('dismiss-for-days'),
        delaySeconds = this.$container.data('delay-seconds'),
        showPopup = true,
        testMode = this.$container.data('test-mode'),
        lastDismissed = window.localStorage.getItem(dismissedStorageKey);

      // Should we show it during this page view?
      // Check when it was last dismissed
      if (lastDismissed) {
        var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);
        if (dismissedDaysAgo < dismissForDays) {
          showPopup = false;
        }
      }

      // Check for error or success messages
      if (this.$container.find('.cc-popup-form__response').length) {
        showPopup = true;
        delaySeconds = 1;

        // If success, set as dismissed
        if (this.$container.find('.cc-popup-form__response--success').length) {
          this.functions.popupSetAsDismissed.call(this);
        }
      }

      // Prevent popup on Shopify robot challenge page
      if (document.querySelector('.shopify-challenge__container')) {
        showPopup = false;
      }

      // Show popup, if appropriate
      if (showPopup || testMode) {
        setTimeout(() => {
          this.popup.open();
        }, delaySeconds * 1000);
      }

      // Click on close button or modal background
      this.$container.on('click' + this.namespace, '.cc-popup-close, .cc-popup-background', () => {
        this.popup.close(() => {
          this.functions.popupSetAsDismissed.call(this);
        });
      });
    };

    this.onSectionSelect = function () {
      this.popup.open();
    };

    this.functions = {
      /**
       * Use localStorage to set as dismissed
       */
      popupSetAsDismissed: function popupSetAsDismissed() {
        window.localStorage.setItem(dismissedStorageKey, new Date().getTime());
      }
    };

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    this.onSectionUnload = function () {
      this.$container.off(this.namespace);
    };
  }();

   // Register section
  cc.sections.push({
    name: 'newsletter-popup',
    section: theme.Popup
  });